import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import ClipboardButton from 'react-clipboard.js';

import iconLink from 'assets/images/icons/icon-link-dark.svg';
import iconCheck from 'assets/images/icons/check-icon.svg';
import Modal from 'components/Modal';

import styles from './ShareDialog.scss';
import { useTranslation } from 'react-i18next';
import Checkbox from '../common/Checkbox';
import { makeBase64, firstLetterToUpper } from '../Building/Main/helper';
import tracker from '../../services/tracker';


const ShareDialog = ({ onClose, shareId, building }) => {
  const [showNotification, setShowNotification] = useState(false);
  const [values, setValues] = useState({
    nameAddress: true,
    description: true,
    characteristics: true,
    communications: true,
    checkout: true,
    payment: true,
    lots: true
  });
  const [url, setUrl] = useState('');
  const [hash, setHash] = useState('');
  const { t } = useTranslation();

  const handleInputFocus = (e) => {
    e.target.selectionStart = 0;
    e.target.selectionEnd = e.target.value.length;

    tracker.sendEvent('Web_ShareDialog_Link');
  };

  const handleClipboardClick = () => {
    setShowNotification(true);
    tracker.sendEvent('Web_ShareDialog_CopyButton');
    setTimeout(
      () => this.setState({ showNotification: false }), 5000
    );
  };

  const handlePdfClick = () => {
    tracker.sendEvent('Web_ShareDialog_SavePdf', {
      id: building.data.id,
      name: building.data.title
    });

    const link = document.createElement('a');
    link.href = `https://api.nedvex.ru/share-building/pdf/${hash}`;
    link.download = 'file.pdf';
    link.target = '__blank';
    link.dispatchEvent(new MouseEvent('click'));
    link.remove();
  };

  const handleChange = (name, value) => {
    tracker.sendEvent(`Web_ShareDialog_${firstLetterToUpper(name)}`, {
      selected: value
    });
    setValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  useEffect(() => {
    makeBase64({
      id: shareId,
      values
    }).then((hashValue) => {
      setHash(hashValue);
      setUrl(
        `${window.location.origin}/nbref/${hashValue}`
      );
    });
  }, [values]);

  return (
    <Modal
      isOpen
      handleClose={onClose}
      title={t('components.shareDialog.sendObject')}
      contentStyle={{
        width: '583px',
        margin: 'auto'
      }}
    >
      <div className={styles.Modal}>
        <p className={styles.ModalDescription}>
          {t('components.shareDialog.title')}
        </p>
        <div className={styles.ModalCheckboxes}>
          <Checkbox
            checked={values.nameAddress}
            handle={(value) => handleChange('nameAddress', value)}
            text={'Название и адрес'}
          />
          <Checkbox
            checked={values.description}
            handle={(value) => handleChange('description', value)}
            text={'Описание и преимущества'}
          />
          <Checkbox
            checked={values.characteristics}
            handle={(value) => handleChange('characteristics', value)}
            text={'Общие характеристики'}
          />
          <Checkbox
            checked={values.communications}
            handle={(value) => handleChange('communications', value)}
            text={'Коммуникации'}
          />
          <Checkbox
            checked={values.checkout}
            handle={(value) => handleChange('checkout', value)}
            text={'Оформление'}
          />
          <Checkbox
            checked={values.payment}
            handle={(value) => handleChange('payment', value)}
            text={'Оплата'}
          />
          <Checkbox
            checked={values.lots}
            handle={(value) => handleChange('lots', value)}
            text={'Лоты'}
          />
        </div>
        <p className={styles.SendLink}>
          {t('components.shareDialog.hint')}
        </p>
        <div className={styles.SendCollectionInputWrap}>
          <img src={iconLink} alt="" />
          <input readOnly value={url} className={styles.SendCollectionInput} onFocus={handleInputFocus} />
        </div>

        <ClipboardButton className={cn(styles.SendCollectionBtn, 'button-primary', 'button-primary--sm')} data-clipboard-text={url} onClick={handleClipboardClick}>
          {t('components.shareDialog.copy')}
        </ClipboardButton>

        <button className={cn(styles.SendPdf)} onClick={handlePdfClick}>
          {t('components.shareDialog.savePdfFile')}
        </button>

        {showNotification
          ? (
            <span className={styles.ModalNotification}>
              <img src={iconCheck} alt={t('components.shareDialog.copied')} /> {t('components.shareDialog.copied')}
            </span>
          )
          : null}
      </div>
    </Modal>
  );
};

export default React.memo(ShareDialog);



// WEBPACK FOOTER //
// ./src/components/ShareDialog/ShareDialog.js